import { defaultToolbarItems } from '@/lib/components/Shared/editor/ckeditor/toolbar/Toolbar';
import { PropType } from 'vue';
import type { ToolbarConfigItem } from 'ckeditor5';

type LanguageObject = {
	[languageCode: string]: {
		[property: string]: string | null;
	};
};

type MultilingualProps = {
	mode: string;
	required: boolean;
	resource: {
		translated: LanguageObject | null | [];
	};
	property: string;
	maxLength: number;
	markdownMode: string;
	labelledBy: string | null;
};

const props = {
	allowsAttachments: {
		type: Boolean,
		default: false,
		description: 'True means file uploads are allowed. Valid uploader options are also required.',
	},
	allowsInlineImages: {
		type: Boolean,
		default: false,
		description: 'True means inline image uploads are allowed. Valid uploader options are also required.',
	},
	mode: {
		type: String,
		default: 'text',
		validator: (mode: string) => ['text', 'textarea', 'editor'].includes(mode),
	},
	required: {
		type: Boolean,
		default: false,
	},
	resource: {
		type: Object,
		required: true,
		validator: (resource: object) => Object.prototype.hasOwnProperty.call(resource, 'translated'),
	},
	property: {
		type: String,
		required: true,
	},
	maxLength: {
		type: Number,
		default: 524288,
	},
	markdownMode: {
		type: String,
		default: 'single-line',
		validator: (mode: string) => ['full', 'single-line'].includes(mode),
	},
	labelledBy: {
		type: String,
		default: null,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	inputClass: {
		type: String,
		default: null,
	},
	toolbar: {
		type: Array as PropType<ToolbarConfigItem[]>,
		default: () => defaultToolbarItems,
	},
	removeItemsToolbar: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
};

export { MultilingualProps, props, LanguageObject };
